import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CookieBanner } from '../privacy/CookieBanner';
import { ThemeToggle, usePublicTheme } from './PublicTheme';

export function PublicLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const { theme, toggle } = usePublicTheme();
  const year = new Date().getFullYear();
  // Klasa `.public-dark` jest dodawana do <html> przez `usePublicTheme`
  // (useLayoutEffect). Tutaj wystarczy używać `dark:` utility — kompilują się
  // do `.public-dark <selector>` (zob. tailwind.config.ts).
  return (
    <div className="flex min-h-full flex-col bg-gradient-to-br from-brand-50 via-zinc-50 to-zinc-100 dark:from-zinc-950 dark:via-zinc-900 dark:to-zinc-900 dark:text-zinc-100">
      <header className="border-b border-zinc-200 bg-white/80 backdrop-blur dark:border-zinc-800 dark:bg-zinc-900/80">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3 sm:px-6">
          <Link to="/rezerwacja" className="flex flex-col leading-tight">
            <span className="text-base font-semibold text-zinc-900 dark:text-zinc-100">
              {t('publicBooking.header')}
            </span>
            <span className="text-xs text-zinc-500 dark:text-zinc-400">{t('publicBooking.subtitle')}</span>
          </Link>
          <div className="flex items-center gap-3">
            <ThemeToggle theme={theme} onToggle={toggle} />
            <Link
              to="/login"
              className="hidden text-xs text-zinc-500 hover:text-brand-700 dark:text-zinc-400 dark:hover:text-brand-300 sm:inline"
            >
              {t('publicBooking.loginLink')} →
            </Link>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-6 sm:px-6 sm:py-10">{children}</main>
      <footer className="border-t border-zinc-200 bg-white/60 dark:border-zinc-800 dark:bg-zinc-900/60">
        <div className="mx-auto flex max-w-4xl flex-col items-start justify-between gap-2 px-4 py-4 text-xs text-zinc-500 dark:text-zinc-400 sm:flex-row sm:items-center sm:px-6">
          <span>© {year} {t('publicBooking.header')}</span>
          <nav className="flex gap-4">
            <Link to="/privacy" className="hover:text-brand-700 dark:hover:text-brand-300">
              {t('publicBooking.footer.privacy')}
            </Link>
            <Link to="/login" className="hover:text-brand-700 dark:hover:text-brand-300">
              {t('publicBooking.loginLink')}
            </Link>
          </nav>
        </div>
      </footer>
      <CookieBanner />
    </div>
  );
}
